import createBuyerIntentClick from './createBuyerIntentClick'

const BuyerIntentAdClick = createBuyerIntentClick({
  displayName: 'BuyerIntentAdClick',
  eventName: '/ad/clicked',
})

export default BuyerIntentAdClick
